<template>
  <div class="OtpVerification">
    <div class="background-image"></div>


    <div class="login-card-position">
      <el-card class="box-card">
        <div class="logo-section text-center" @click="goToLink('/')">
          <img src="../assets/images/logo/logo1.png" class="cursor-pointer" style="width: 200px;" />
        </div>

        <div class="top-margin-20">
          <div v-if="is_otp">
            <div class="top-margin-15">
              <div class="input-group-section">
                <div class="form-group" :class="{'not-empty': otp.length , 'form-group--error':  showErrorOnEmpty && $v.otp.$error }">
                  <label class="input-label block bottom-margin-5">ENTER OTP</label>

                  <el-input
                    type="text"
                    class="form-control"
                    name="otp"
                    v-model="otp"
                    @input="setOtp($event)"
                  ></el-input>
                </div>
                <div class="error" v-if="showErrorOnEmpty && !$v.otp.required">Field is required</div>
              </div>
            </div>

            <div class="text-center top-margin-25">
              <el-button rounded class="btn-secondary-theme-filled" style="width: 70%;" v-on:click="verifyOtp()" :loading="is_vefiry_otp_btn_loading">VERIFY OTP</el-button>
            </div>

            <div class="text-center top-margin-5">
              <span style="color: #000; font-size: 0.7rem; font-weight: 400;">Sometimes automated mails get categorised as spam. <br /> Check your spam folder</span>
            </div>

            <div class="text-center top-margin-5">
              <span style="font-size: 0.9rem; font-weight: 300; text-decoration: underline; cursor: pointer;" v-on:click="switchPage('reSendOtp')">Resend OTP</span>
            </div>
          </div>

          <div v-if="is_resend_otp">
            <div class="margin-top-15">
              <div class="input-group-section">
                <div class="form-group" :class="{'not-empty': email.length , 'form-group--error':  showErrorOnEmpty && $v.email.$error }">
                <label class="input-label block bottom-margin-5">EMAIL</label>

                  <el-input
                    type="email"
                    class="form-control"
                    name="resendOtp"
                    v-model="email"
                    @input="setEmail($event)"
                  ></el-input>
                </div>
                <div class="error" v-if="showErrorOnEmpty && !$v.email.required">Field is required</div>
              </div>
            </div>

            <div class="text-center top-margin-25">
              <el-button rounded class="btn-secondary-theme-filled" style="width: 70%;" v-on:click="reSendOtp()" :loading="is_resend_otp_btn_loading">RESEND OTP</el-button>
            </div>

            <div class="text-center top-margin-5">
              <span style="font-size: 0.9rem; font-weight: 300; text-decoration: underline; cursor: pointer;" v-on:click="switchPage('verifyOtp')">Verify OTP</span>
            </div>
          </div>

          <div class="text-center top-margin-5">
            <span style="color: #000; font-size: 0.9rem; font-weight: 300;">Already have an account?</span>&nbsp;
            <span  style="color: #000; font-size: 0.9rem; font-weight: 300; border-bottom: 1px solid #000; cursor: pointer;" @click="goToLink('/login')">Login</span>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { serverAddr } from "../networkConfig";
import { loginNetworkCallBack } from "../mixins/login.NetworkCallback";
import { required } from "vuelidate/lib/validators";
import CripNotice from 'crip-vue-notice';

export default {
  name: "OtpVerification",

  mixins: [loginNetworkCallBack],

  data() {
    return {
      is_otp: true,
      is_resend_otp: false,
      email: "",
      otp: "",
      showErrorOnEmpty: false,
      is_vefiry_otp_btn_loading: false,
      is_resend_otp_btn_loading: false
    };
  },

  validations: {
    otp: {
      required
    },
    email: {
      required
    }
  },

  methods: {
    goToLink(link){
      if(link){
        this.$router.push(link);
      }
    },

    switchPage(value) {
      if (value == "reSendOtp") {
        this.otp = "";
        this.email = "";
        this.is_resend_otp = true;
        this.is_otp = false;
      } else if (value == "verifyOtp") {
        this.otp = "";
        this.email = "";
        this.is_resend_otp = false;
        this.is_otp = true;
      }
    },

    setOtp(value) {
      this.otp = value;
      this.$v.otp.$touch();
    },

    setEmail(value) {
      this.email = value;
      this.$v.email.$touch();
    },

    verifyOtp() {
      this.showErrorOnEmpty = true;
      this.$v.$touch();
      if (this.otp.trim().length) {
        this.is_vefiry_otp_btn_loading = true;
        serverAddr
          .post("/auth/v1/validate_email_otp", {
            email_otp: Number(this.otp),
            purpose: this.$route.params.key ? this.$route.params.key.toUpperCase() : 'SIGN_UP',
            email_id: localStorage.getItem('auth_email')
          })
          .then(this.verifyOtpNetworkCallBack)
          .catch(function(error) {
            console.log(error);
            this.is_vefiry_otp_btn_loading = false;
            // new CripNotice({
            //   title: "Error",
            //   description: 'Pleae enter valid OTP',
            //   type: "error",
            //   duration: 3,
            // });
          }.bind(this));
      }
    },

    reSendOtp() {
      this.showErrorOnEmpty = true;
      this.$v.$touch();

      if (this.email.trim().length) {
        this.is_resend_otp_btn_loading = true;
        serverAddr
          .post("/auth/v1/generate_email_otp", {
            email_id: this.email,
            purpose: this.$route.params.key ? this.$route.params.key.toUpperCase() : 'SIGN_UP',
          })
          .then(this.resendOtpNetworkCallBack)
          .catch(function(error) {
            console.log(error);
            this.is_resend_otp_btn_loading = false;
          });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../css/common.scss";
@import "../css/variable.scss";

.OtpVerification{
  .background-image {
    background-image: url("../assets/images/login/mobilebg.png");
    height: 100vh;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    opacity: 1;
  }
  .box-card{
    border-radius: 10px;
    margin: 0.4rem;
  }
  .login-card-position {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 450px;
  }
  .input-group-section {
    margin-bottom: 16px;
  }

  @media screen and (max-width: 450px) {
    .login-card-position{
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
@import "../css/variable.scss";
.OtpVerification .el-button.is-loading:before {
  background-color: $primary-theme-color;
  position: relative;
}
.OtpVerification .el-button .el-icon-loading {
  font-weight: bold;
}
</style>
